// Composant FounderBadge - Badge "Membre Fondateur"
// Affiché sur les profils des utilisateurs qui ont rejoint le programme Fondateur

import { Crown } from 'lucide-react';

/**
 * Badge Fondateur pour les utilisateurs VIP
 * @param {number} founderNumber - Numéro du fondateur (#1, #2, etc.)
 * @param {string} size - "sm", "md", "lg"
 * @param {boolean} showLabel - Afficher le texte ou juste l'icône
 * @param {boolean} showNumber - Afficher le numéro du fondateur
 */
export function FounderBadge({ founderNumber, size = 'md', showLabel = true, showNumber = false }) {
  // Configurations de taille
  const sizes = {
    sm: {
      icon: 12,
      padding: '2px 6px',
      fontSize: '10px',
      gap: 4
    },
    md: {
      icon: 14,
      padding: '4px 10px',
      fontSize: '12px',
      gap: 5
    },
    lg: {
      icon: 16,
      padding: '6px 14px',
      fontSize: '14px',
      gap: 6
    }
  };

  const config = sizes[size] || sizes.md;

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: config.gap,
        padding: config.padding,
        borderRadius: 20,
        fontSize: config.fontSize,
        fontWeight: 600,
        whiteSpace: 'nowrap',
        background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
        color: 'white',
        boxShadow: '0 2px 8px rgba(16,185,129,0.3)'
      }}
      title={founderNumber ? `Membre Fondateur #${founderNumber}` : "Membre Fondateur - Pionnier d'AbracadaBati"}
    >
      <Crown size={config.icon} />
      {showLabel && (
        <span>
          Fondateur{showNumber && founderNumber ? ` #${founderNumber}` : ''}
        </span>
      )}
    </span>
  );
}

/**
 * Badge compact (juste l'icône couronne verte avec tooltip)
 */
export function FounderBadgeIcon({ founderNumber, size = 16 }) {
  return (
    <Crown 
      size={size} 
      style={{ 
        color: '#10b981', 
        fill: '#10b981', 
        opacity: 0.9 
      }} 
      title={founderNumber ? `Fondateur #${founderNumber}` : 'Membre Fondateur'}
    />
  );
}

export default FounderBadge;
